<router-outlet></router-outlet>
<fund-base-size-detector (onSizeChanged)="onScreenSizedChanged($event)"></fund-base-size-detector>
<!-- global loader-->
<div *ngIf="globalLoading$ | async" class="global-loader">
  <app-loader></app-loader>
</div>
<!-- AI chat widget -->
<app-ai-chat-widget></app-ai-chat-widget>
